// https://stackoverflow.com/questions/26629180/changing-the-case-of-javascript-object-keys

export default function uncapitaliseKeys(obj) {
  const isObject = o => Object.prototype.toString.apply(o) === '[object Object]'
  const isArray = o => Object.prototype.toString.apply(o) === '[object Array]'

  let transformedObj = isArray(obj) ? [] : {}

  for (let key in obj) {
    // replace the following with any transform function
    let transformedKey = key.replace(/^\w/, (c, _) => c.toLowerCase())
    if (transformedKey === 'iD') {
      transformedKey = 'id';
    }

    if (isObject(obj[key]) || isArray(obj[key])) {
      transformedObj[transformedKey] = uncapitaliseKeys(obj[key])
    } else {
      transformedObj[transformedKey] = obj[key]
    }
  }
  return transformedObj
}
